var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var cns = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args
        .filter(function (a) { return a !== null && a !== undefined && a !== false && a !== ''; })
        .join(' ');
};
var subClass = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.join('-');
};
var currySC = function (original) { return function () {
    var subclasses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        subclasses[_i] = arguments[_i];
    }
    return subClass.apply(void 0, __spreadArrays([original], subclasses));
}; };
export { currySC, cns, subClass };
//# sourceMappingURL=utils.js.map